module.exports = __webpack_public_path__ + "static/Pech.121d1f6e.png";